const actions = {
	OPEN_VMWARE_PORTAL: 'OPEN_VMWARE_PORTAL',
	openVmwarePortal: ({ uniqId }) => ({
		type: actions.OPEN_VMWARE_PORTAL,
		uniqId,
	}),
};

export default actions;
